/**
 * MobiliCal — prototype page for the custom calendar engine (see
 * docs/calendar-drop-in-replacement-plan.md). Gated behind chief + Debug UI
 * via useChiefDebugAccess, same as the admin maintenance module.
 *
 * The page is only the access gate: toolbar, drawers, shelf and calendar all
 * live in MobiliScheduler (the toolbar sits in its center column so the
 * patient drawer can never cover it).
 */
import { RocketLaunch } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import { useChiefDebugAccess } from "../../hooks/useChiefDebugAccess";
import { mobiliTheme } from "../../themes/mobiliTheme";
import MobiliScheduler from "./MobiliScheduler";

const MobiliCalendarPage: React.FC = observer(() => {
  const hasAccess = useChiefDebugAccess();

  if (!hasAccess) {
    // debugUI is session-only (resets on reload), so show a hint instead of
    // redirecting — also avoids a premature redirect while auth bootstraps.
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          color: "text.secondary",
        }}
      >
        <RocketLaunch sx={{ fontSize: 42, color: mobiliTheme.mainHeader }} />
        <Typography variant="h6">MobiliCal Prototyp</Typography>
        <Typography variant="body2" sx={{ maxWidth: 420, textAlign: "center" }}>
          Sichtbar nur mit Chief-Rolle und aktiviertem Debug UI (Profilmenü →
          „Debug UI“). Nach dem Aktivieren erscheint der Menüpunkt „MobiliCal“ in
          der Seitenleiste.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: "100%", minHeight: 0, p: 1 }}>
      <MobiliScheduler />
    </Box>
  );
});

export default MobiliCalendarPage;
